export default __webpack_public_path__ + "static/media/trace_logo.588461e7.png";